/* eslint-disable array-callback-return */
import {useEffect, useState} from 'react';
import './SegnalazioneCreate.css'
import SegnalazioneCreateSection from './sections/SegnalazioneCreateSection';
import SegnalazioneCreateSectionUploadFiles from './section_upload_files/SegnalazioneCreateSectionUploadFiles';
import CustomButton from '../../shared/atomic_components/button/CustomButton';
import CustomButtonSecondary from '../../shared/atomic_components/button/CustomButtonSecondary';
import CONSTANTS from "../../shared/utils/Constants"
import SegnalazioniStructureService from '../../services/controllers/segnalazioni-services/SegnalazioniStructureService';
import SegnalazioneTypeLabels from '../../shared/variables/SegnalazioneTypeLabels';
import { Fields, Section } from '../../services/models/objs/StorSection';
import User from '../../services/models/output-objs/User';
import { GetCatalogList } from '../../services/controllers/catalogs-services/CatalogsStructureService';
import { SendingStorOutput } from '../../services/models/output-objs/sendingStoreOutput';
import StorBeFeParser from '../../shared/utils/storBeFeParser';
import { SegnalazioniService } from '../../services/controllers/segnalazioni-services/SegnalazioniService';
import { UserInfo } from '../../services/models/output-objs/UserInfo';
import {TextField} from "@mui/material";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import InputAdornment from '@mui/material/InputAdornment';
import EventIcon from '@mui/icons-material/Event';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

type SegnalazioneCreateType = {
    notificationFunctions : any,
    user : User,
    userInfo : UserInfo
}

const SegnalazioneCreate = ({notificationFunctions, user, userInfo} : SegnalazioneCreateType) => {

    const [newSegnalazione, setNewSegnalazione] = useState< {[key : string] : any}>({})
    const [currentSection, setCurrentSection] = useState<Section>({} as Section)
    const [currentSectionPage, setCurrentSectionPage] = useState("0")
    const [passedSections, setPassedSections] = useState<string[]>([])
    const [errorClickingNextSection, setErrorClickingNextSection] = useState(false)
    const [segnalazioneChoiceLists, setSegnalazioneChoiceLists] = useState({})
    const [foreignAuthority, setForeignAuthority] = useState(()=>{
        let catalogueList = JSON.parse(sessionStorage.getItem("catalogueList") || '')
        return catalogueList? catalogueList.foreignAuth : []
    })
    const [sections, setSections] = useState<Section[]>([])
    const [disabledButton,setDisabled] = useState<boolean>(()=>{
        if(sessionStorage.getItem('SegnalazioneInviataAzione')=='rettifica')
            return false
        else
            return true
    })
    const [reminder, setReminder] = useState<boolean>(false)
    const maxDate = new Date();

    useEffect(() => {
        let section = 0
        const role = user?.ldapSource || ""
        if (!sessionStorage.getItem("segnalazioneType"))
            window.location.href = "/stor-fe";
        const segnalazioneStructure = SegnalazioniStructureService.getStructure(sessionStorage.getItem('segnalazioneType') || '', role)
        getSegnalazioneChoiceList();
        setSections(segnalazioneStructure.sections)
        setCurrentSection(segnalazioneStructure.sections[0])
        if (sessionStorage.getItem("newSegnalazione")){
            setNewSegnalazione(JSON.parse(sessionStorage.getItem("newSegnalazione") || ''))
            let tmpSegnalazione = JSON.parse(sessionStorage.getItem("newSegnalazione") || '')
            if(tmpSegnalazione['systemInformations']['pageNumber']){
                section = +tmpSegnalazione['systemInformations']['pageNumber']
            }
            setCurrentSection(segnalazioneStructure.sections[section])
            setCurrentSectionPage(section.toString())
        }
        else{
            initNewSegnalazione(segnalazioneStructure.sections)
        }
    }, [])

    async function getSegnalazioneChoiceList(){
        const res = await GetCatalogList();
        setSegnalazioneChoiceLists(res);
    }

    async function initNewSegnalazione(sections : Section[]) {
        sessionStorage.removeItem('idSegnalazioneCreazione')
        const tmpNewSegnalazione : {[key : string] : any}= {}
        sections.map(section => {
            tmpNewSegnalazione[section.id] = {}
            section.subSections.map((subsection => {
                tmpNewSegnalazione[section.id][subsection.id] = {}
                subsection.fields.map(field => {
                    if (subsection.multipleValue)
                        tmpNewSegnalazione[section.id][subsection.id] = []
                    else
                        tmpNewSegnalazione[section.id][subsection.id][field.name] = ''
                })
            }))
        })
        if(Object.keys(user).length !== 0){
            let tmpProvince = userInfo.address?.province?.toLowerCase();
            if(tmpProvince) {
                let first = tmpProvince[0].toUpperCase();
                tmpProvince = first + tmpProvince.slice(1);
            }
            tmpNewSegnalazione['identitaSegnalante']['datiAnagraficiSegnalante']['nomeSoggettoSegnalante'] = userInfo.name;
            tmpNewSegnalazione['identitaSegnalante']['datiAnagraficiSegnalante']['codiceLEI'] = userInfo.leiCode;
            tmpNewSegnalazione['identitaSegnalante']['datiAnagraficiSegnalante']['tipoSoggettoSegnalante'] = userInfo.subjectType?.name;
            tmpNewSegnalazione['identitaSegnalante']['datiAnagraficiSegnalante']['tipoSoggettoSegnalanteId'] = userInfo.subjectType?.id;
            tmpNewSegnalazione['identitaSegnalante']['datiAnagraficiSegnalante']['formaGiuridica'] = userInfo.legalForm?.name;
            tmpNewSegnalazione['identitaSegnalante']['datiAnagraficiSegnalante']['formaGiuridicaId'] = userInfo.legalForm?.id;
            tmpNewSegnalazione['identitaSegnalante']['datiAnagraficiSegnalante']['via'] = userInfo.address?.address;
            tmpNewSegnalazione['identitaSegnalante']['datiAnagraficiSegnalante']['numCivico'] = userInfo.address?.buildingNumber;
            tmpNewSegnalazione['identitaSegnalante']['datiAnagraficiSegnalante']['codPostale'] = userInfo.address?.zipCode;
            tmpNewSegnalazione['identitaSegnalante']['datiAnagraficiSegnalante']['nazione'] = userInfo.address?.country?.name;
            tmpNewSegnalazione['identitaSegnalante']['datiAnagraficiSegnalante']['nazioneId'] = userInfo.address?.country?.id;
            tmpNewSegnalazione['identitaSegnalante']['datiAnagraficiSegnalante']['provincia'] = tmpProvince;
            tmpNewSegnalazione['identitaSegnalante']['datiAnagraficiSegnalante']['regione'] = userInfo.address?.city;
        }
        tmpNewSegnalazione['systemInformations'] = {}
        tmpNewSegnalazione['systemInformations']['type'] = sessionStorage.getItem('segnalazioneType')
        tmpNewSegnalazione['documentazioneAllegata'] = {}
        tmpNewSegnalazione['documentazioneAllegata']['documentiAllegati'] = []
        sessionStorage.setItem('newSegnalazione', JSON.stringify(tmpNewSegnalazione))
        setNewSegnalazione(tmpNewSegnalazione)
    }

    function getCircleClass(idSection : string) {
        if (currentSectionPage === idSection)
            return 'custom-circle-selected'
        else if (currentSection === undefined)
            return 'custom-circle-passed'
        else if (idSection === currentSection.id)
            return 'custom-circle-selected'
        else if (passedSections.includes(idSection))
            return 'custom-circle-passed'
        return 'custom-circle'
    }

    function nextSection() {
        if(sessionStorage.getItem('SegnalazioneInviataAzione')!='rettifica'){
            setDisabled(true)
        }
        else{
            saveStor();
        }
        passedSections.push(currentSection.id)
        window.scrollTo(0, 0);
        const numberPage = Number(currentSectionPage)
        const newCurrentSectionPage = numberPage + 1
        const completedSection : any  = isCompletedSection()
        if (completedSection.allRequiredFieldsAreFilled)
            changeSection(newCurrentSectionPage)
        else
            handleSegnalazioneIsNotComplete(completedSection)
    }

    function previousSection() {
        passedSections.pop()
        window.scrollTo(0, 0);
        const page = Number(currentSectionPage)
        const newCurrentSectionPage = page - 1
        changeSection(newCurrentSectionPage)
    }

    function changeSection(newCurrentSectionPage : number) {
        setCurrentSection(sections[newCurrentSectionPage])
        const pageString = newCurrentSectionPage.toString()
        setCurrentSectionPage(pageString)
        setErrorClickingNextSection(false)
    }

    function handleSegnalazioneIsNotComplete(completedSection : any) {
        setErrorClickingNextSection(true)
        if (completedSection.subsectionsWithMultiValueNotCompleted) {
            notificationFunctions.setErrorMessage('Inserire almeno un elemento della sezione ' + completedSection.subsectionsWithMultiValueNotCompleted[0])
        }
        else if(completedSection.orderOperationNotComplete){
            notificationFunctions.setErrorMessage('Ogni strumento finanziario deve essere completo di data, luogo e descrizione')
        }
        else {
            setErrorClickingNextSection(true)
            notificationFunctions.setErrorMessage(CONSTANTS.labelFillAllRequiredFields)
        }
    }

    async function saveStor(){
        if(user.ldapSource?.toLowerCase().includes(CONSTANTS.internalUserRole)  && newSegnalazione && newSegnalazione['systemInformations']['codiceProtocollo']){
            if(!newSegnalazione['systemInformations']['codiceProtocollo'].includes('/')){
                notificationFunctions.setErrorMessage('Il formato del codice protocollo non risulta corretto')
                return
            }
        }
        const completedSection : any  = isCompletedSection()
        if (completedSection.allRequiredFieldsAreFilled && !completedSection.orderOperationNotComplete){
            if(newSegnalazione.ordineOperazione && newSegnalazione.ordineOperazione.descrizioneOrdine?.constructor !== Array)
                setReminder(true)
            else
                setReminder(false)
            const segnalazioniService : SegnalazioniService = new SegnalazioniService();
            const segnalazioneT = newSegnalazione['systemInformations'] ? SegnalazioneTypeLabels[newSegnalazione['systemInformations']['type']] : ""
            const sendingStor : SendingStorOutput = StorBeFeParser.parseFetoBe(newSegnalazione,segnalazioneT,'0',sessionStorage?.getItem('idSegnalazioneCreazione') || null)
            const result = await segnalazioniService.saveStor(sendingStor)
            if(result && result.id){
                sessionStorage.setItem('idSegnalazioneCreazione', result?.id || '')
                if(sessionStorage.getItem('SegnalazioneInviataAzione')!='rettifica' && sessionStorage.getItem('fromAggiornamento')!=='true'){
                    notificationFunctions.setSuccessMessage('Segnalazione salvata con successo')
                }
                if(result.attachments && result.attachments.length > 0){
                    newSegnalazione['documentazioneAllegata']['documentiAllegati'] = result.attachments
                    sessionStorage.setItem('newSegnalazione', JSON.stringify(newSegnalazione))
                }
                setDisabled(false)
            }
            else {
                notificationFunctions.setErrorMessage('Errore nel salvataggio della segnalazione')
            }
        }
        else {
            handleSegnalazioneIsNotComplete(completedSection)
        }
        
    }
    

    async function goToSummary() {
        if(sessionStorage.getItem('SegnalazioneInviataAzione')!='rettifica')
            setDisabled(true)
        const segnalazioniService : SegnalazioniService = new SegnalazioniService();
        const response = await segnalazioniService.getStorByID(sessionStorage?.getItem('idSegnalazioneCreazione') || sessionStorage?.getItem('idSegnalazione') || '');
        if (response && response.id){
            const parsedSegnalazione = await StorBeFeParser.parseBetoFe(response)
            sessionStorage.setItem('newSegnalazione', JSON.stringify(parsedSegnalazione))
            sessionStorage.setItem('arrivedFromSegnalazioneCreate', 'true')
            window.location.href = '/stor-fe/stor/detail'
        }
    }

    function isCompletedSection() {
        const response : {[key : string] : any} = {}
        const page = Number(currentSectionPage)
        if (page === sections.length){
            response['allRequiredFieldsAreFilled'] = true
        }
        else{
            let numberOfRequiredFieldNotFilled = 0
            if(newSegnalazione && newSegnalazione["identitaSegnalante"]["vesteSegnalante"] && 
            ((newSegnalazione["identitaSegnalante"]["vesteSegnalante"]["catTipologiaStrumNegoziatoId"] && newSegnalazione["identitaSegnalante"]["vesteSegnalante"]["catTipologiaStrumNegoziatoId"] === 22)
            || (newSegnalazione["identitaSegnalante"]["vesteSegnalante"]["catTipologiaStrumNegoziatoId"] && newSegnalazione["identitaSegnalante"]["vesteSegnalante"]["vesteSegnalanteId"] === 11) 
            || (newSegnalazione["identitaSegnalante"]["vesteSegnalante"]["catTipologiaStrumNegoziatoId"] && newSegnalazione["identitaSegnalante"]["vesteSegnalante"]["catTipologiaNegoziazioneId"] === 44))){
                if(currentSection.id === "identitaSegnalante")
                    currentSection.subSections[2].fields[4].required = true;
            }
            else{
                if(currentSection.id === "identitaSegnalante")
                    currentSection.subSections[2].fields[4].required = false;
            }
            currentSection.subSections.map(subSection => {
                if (subSection.multipleValue) {
                    subSection.fields.map(field => {
                        if (field.required && newSegnalazione[currentSection.id][subSection.id].length === 0) {
                            numberOfRequiredFieldNotFilled++
                            if (!response['subsectionsWithMultiValueNotCompleted'])
                                response['subsectionsWithMultiValueNotCompleted'] = []
                            response['subsectionsWithMultiValueNotCompleted'].push(subSection.name)
                        }
                    })
                }
                else {
                    subSection.fields.map(field => {
                        if (field.required) {
                            if (!newSegnalazione[currentSection.id][subSection.id][field.name]) {
                                numberOfRequiredFieldNotFilled++
                            }
                        }
                    })
                }
            })
            if (numberOfRequiredFieldNotFilled === 0)
                response['allRequiredFieldsAreFilled'] = true
            if(currentSection && currentSection.id === "ordineOperazione"){
                let countCheck = false
                if(newSegnalazione[currentSection.id].descrStrumFinanziario.length !== 0){
                    newSegnalazione[currentSection.id].descrStrumFinanziario.map((str : any)=>{
                        if(newSegnalazione[currentSection.id].dataOraOrdine.constructor === Array && newSegnalazione[currentSection.id].dataOraOrdine.length !== 0){
                            newSegnalazione[currentSection.id].dataOraOrdine.map((dataOrdine : any)=>{
                                if(dataOrdine && dataOrdine.codiceStrumFinanaziario === str.codiceIdentificativo)
                                    countCheck = true;
                            })
                        }
                        else if(newSegnalazione[currentSection.id].dataOraOrdine.constructor !== Array){
                            if(newSegnalazione[currentSection.id].dataOraOrdine && newSegnalazione[currentSection.id].dataOraOrdine.codiceStrumFinanaziario === 'all')
                                countCheck = true;
                        }
                        if(!countCheck)
                            response['orderOperationNotComplete'] = true
                        countCheck = false       

                        if(newSegnalazione[currentSection.id].nazione.constructor === Array && newSegnalazione[currentSection.id].nazione.length !== 0){
                            newSegnalazione[currentSection.id].nazione.map((nazione : any)=>{
                                if(nazione && nazione.codiceStrumFinanaziario === str.codiceIdentificativo)
                                    countCheck = true;
                            })
                        }
                        else if(newSegnalazione[currentSection.id].nazione.constructor !== Array){
                            if(newSegnalazione[currentSection.id].nazione && newSegnalazione[currentSection.id].nazione.codiceStrumFinanaziario === 'all')
                                countCheck = true;
                        }
                        if(!countCheck)
                            response['orderOperationNotComplete'] = true
                        countCheck = false 

                        if(newSegnalazione[currentSection.id].descrizioneOrdine.constructor === Array && newSegnalazione[currentSection.id].descrizioneOrdine.length !== 0){
                            newSegnalazione[currentSection.id].descrizioneOrdine.map((descrizioneOrdine : any)=>{
                                if(descrizioneOrdine && descrizioneOrdine.codiceStrumFinanaziario === str.codiceIdentificativo)
                                    countCheck = true;
                            })
                        }
                        else if(newSegnalazione[currentSection.id].descrizioneOrdine.constructor !== Array){
                            if(newSegnalazione[currentSection.id].descrizioneOrdine && newSegnalazione[currentSection.id].descrizioneOrdine.descrizioneOrdine)
                                countCheck = true;
                        }
                        if(!countCheck)
                            response['orderOperationNotComplete'] = true
                        countCheck = false 
                            //newSegnalazione[currentSection.id].descrizioneOrdine.length !==0
                                            
                    })
                }
            }
        }
        return response;
    }

    function newStorHasFieldMissing(sectionName : string, subSectionName : string, fieldName : string) {
        if (!newSegnalazione[sectionName][subSectionName][fieldName]) return true
        return false
    }

    function fieldIsRequiredAndMissing(storSectionName : string, storSubsectionName : string, field : Fields) {
        if (!field.required) return false
        if (!errorClickingNextSection) return false
        if (newStorHasFieldMissing(storSectionName, storSubsectionName, field.name))
            return true
        return false
    }

    function submitProtocolAndDate(event : any, type : string){
        const tmpNewStor : {[key : string] : any} = {}
        Object.assign(tmpNewStor, newSegnalazione)
        if(type === 'protocol')
            tmpNewStor['systemInformations']['codiceProtocollo'] = event.target.value
        else if(type === 'sendDate'){
            let dateFormatted = event?.toISOString()
            if(dateFormatted)
                dateFormatted =  addHours(event, 2).toISOString()
            tmpNewStor['systemInformations']['dataInvio'] = dateFormatted
        }
        else if(type === 'foreignAut'){
            let id = null
            foreignAuthority?.forEach((list : any) => {
                if(event.target.value === list.name){
                    id = list.id
                }
            });
            tmpNewStor['systemInformations']['autoritaEstera'] = event.target.value
            tmpNewStor['systemInformations']['autoritaEsteraId'] = id
        }
        setNewSegnalazione(tmpNewStor)
        sessionStorage.setItem('newSegnalazione', JSON.stringify(tmpNewStor))
    }

    const addHours = (date: Date, hours: number): Date => {
        const result = new Date(date);
        result.setHours(0,0,0,0)
        result.setHours(result.getHours() + hours);
        return result;
    };

    function getProtocol(){
        if (newSegnalazione['systemInformations'] && newSegnalazione['systemInformations']['codiceProtocollo']){
            return newSegnalazione['systemInformations']['codiceProtocollo']
        }
        else {
            return ""
        }
    }

    function getDateProtocol(){
        if (newSegnalazione['systemInformations'] && newSegnalazione['systemInformations']['dataInvio']) {
            return new Date(newSegnalazione['systemInformations']['dataInvio'])
        }
        else
            return null
    }

    function getForeignAuth(){
        if (newSegnalazione['systemInformations'] && newSegnalazione['systemInformations']['autoritaEstera']) {
            return newSegnalazione['systemInformations']['autoritaEstera']
        }
        else
            return ''
    }

    return (
        <div>
            <div className="row">
                <div className="col-6 d-flex font-x-large-custom mt-5">Nuova segnalazione ({newSegnalazione['systemInformations'] ? SegnalazioneTypeLabels[newSegnalazione['systemInformations']['type']] : ""})</div>
                <div className="col-6 d-flex justify-content-end mt-5">
                    {
                        currentSectionPage === '0' ? <></>
                        :
                        <CustomButtonSecondary onClick={() => {previousSection()}} className="margin-right-5" variant="contained">Precedente</CustomButtonSecondary>
                    }
                    {sessionStorage.getItem('SegnalazioneInviataAzione')=='rettifica' ?
                        <></>
                        :
                        <CustomButtonSecondary onClick={() => {saveStor()}} className="margin-right-5">Salva</CustomButtonSecondary>
                    }
                    {
                        currentSectionPage < sections.length.toString() ?
                            <CustomButton disabled={disabledButton} onClick={() => {nextSection()}} variant="contained">Successivo</CustomButton>
                            :
                            <CustomButton disabled={disabledButton} onClick={() => {goToSummary()}} variant="contained">Vai a riepilogo</CustomButton>
                    }
                </div>
                {user?.ldapSource?.toLowerCase().includes(CONSTANTS.internalUserRole) ?
                    <div className="col-12 d-flex my-3">
                        <div className="col-3 mx-1">
                            <TextField
                                rows={3}
                                onChange={(event => {submitProtocolAndDate(event, 'protocol')})}
                                required={false}
                                fullWidth={true}
                                value={getProtocol()}
                                id={'extraProtocol'}
                                label={'Codice Protocollo Ricevuto'}
                            />  
                        </div>
                        <div className="col-3  mx-1">
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'it'}>
                                <MobileDatePicker
                                        componentsProps={{
                                            actionBar: {
                                                actions: ['clear','accept']
                                            }
                                        }}
                                        label={'Data di invio'}
                                        value={getDateProtocol()}
                                        disableHighlightToday={true}
                                        maxDate={maxDate}
                                        onChange={(date) => {
                                            submitProtocolAndDate(date,'sendDate');
                                        }}
                                        renderInput={(params) => <TextField {...params}
                                            required={false}
                                            fullWidth = {true}
                                            InputProps={{
                                                endAdornment: <InputAdornment position="end">
                                                                <EventIcon/>
                                                            </InputAdornment>,
                                            }}/>
                                        }
                                />
                            </LocalizationProvider>
                        </div>
                        <div className="col-3 mx-1">
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">{'Soggetto Segnalante'}</InputLabel>
                            <Select
                                value={getForeignAuth()}
                                label={'Soggetto Segnalante'}
                                required = {false}
                                onChange={(event => {submitProtocolAndDate(event, 'foreignAut')})}>
                                <MenuItem key="" value="">{'-Seleziona-'}</MenuItem>
                                {foreignAuthority?.map((choice : any) => {
                                    return <MenuItem key={choice.id} value={choice.name}>
                                        {choice.name}
                                    </MenuItem>
                                })}
                            </Select>
                    </FormControl>
                        </div>
                    </div>
                    :
                    <></>
                }
            </div>
            <div className="header row mt-4">
                {sections.map(section => {
                    return <div className="header-element col-md-2 col-sm-6" key={section.id}>
                        <div className={getCircleClass(section.id)}>{section.number}</div>
                        <div className={currentSection && currentSection.id === section.id ? 'mt-2 text-selected' : passedSections.includes(section.id) ? 'text-passed mt-2' : 'mt-2'}>{section.label}</div>
                    </div>
                })}
                <div className="header-element col-md-2 col-sm-6">
                    <div className={getCircleClass(sections.length.toString())}>{sections.length + 1}</div>
                    <div className={currentSectionPage === sections.length.toString()? 'mt-2 text-selected': 'mt-2'}>Documentazione allegata</div>
                </div>
            </div>
            {sections.map(section => {
                return <div key={section.id}>
                    {currentSection && currentSection.id === section.id ?
                        <SegnalazioneCreateSection
                            segnalazioneChoiceLists={segnalazioneChoiceLists}
                            notificationFunctions={notificationFunctions}
                            setNewSegnalazione={setNewSegnalazione}
                            fieldIsRequiredAndMissing={fieldIsRequiredAndMissing}
                            newStorHasFieldMissing={newStorHasFieldMissing}
                            errorClickingNextSection={errorClickingNextSection}
                            newSegnalazione={newSegnalazione}
                            storSectionStructure={section} />
                        :
                            <></>
                    }
                </div>})
            }
            {currentSectionPage === sections.length.toString() ? <SegnalazioneCreateSectionUploadFiles notificationFunctions={notificationFunctions} idStor={sessionStorage?.getItem('idSegnalazioneCreazione') || sessionStorage?.getItem('idSegnalazione') || ''} reminder ={reminder}/> : <></>}
            <div className="mt-4 row">
                <div className="col-6 d-flex color-primary my-auto">
                    {/* <CustomButtonDelete startIcon={<DeleteOutlineOutlinedIcon/>} className="margin-right-5">Cancella segnalazione</CustomButtonDelete> */}
                    {
                        currentSectionPage === '0' ? <></>
                        :
                        <CustomButtonSecondary onClick={() => {previousSection()}} className="margin-right-5" variant="contained">Precedente</CustomButtonSecondary>
                    }
                    <CustomButtonSecondary
                        onClick={() => {
                        sessionStorage.removeItem('SegnalazioneInviataAzione') 
                        sessionStorage.removeItem('idSegnalazione') 
                        sessionStorage.removeItem('idSegnalazioneCreazione')
                        sessionStorage.removeItem('segnalazioneType') 
                        sessionStorage.removeItem('newSegnalazione')  
                        window.location.href = "/stor-fe"}}
                        className="margin-right-5 col-auto"
                        variant="contained">Torna alla homepage</CustomButtonSecondary>
                </div>
                <div className="col-6 d-flex justify-content-end">
                    {sessionStorage.getItem('SegnalazioneInviataAzione')=='rettifica' ?
                        <></>
                        :
                        <CustomButtonSecondary onClick={() => {saveStor()}} className="margin-right-5">Salva</CustomButtonSecondary>
                    }
                    {
                        currentSectionPage < sections.length.toString() ?
                            <CustomButton disabled={disabledButton} onClick={() => {nextSection()}} variant="contained">Successivo</CustomButton>
                            :
                            <CustomButton disabled={disabledButton} onClick={() => {goToSummary()}} variant="contained">Vai a riepilogo</CustomButton>
                    }
                </div>
            </div>
        </div>
    )
}

export default SegnalazioneCreate;
